import { render, staticRenderFns } from "./UpdateDeviationDialog.vue?vue&type=template&id=10bd8ffa&scoped=true&"
import script from "./UpdateDeviationDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateDeviationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd8ffa",
  null
  
)

export default component.exports